import { render, staticRenderFns } from "./EmmaDirectMail.vue?vue&type=template&id=f8f7f43a&"
import script from "./EmmaDirectMail.vue?vue&type=script&lang=ts&"
export * from "./EmmaDirectMail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports